// @flow
import { LayoutAwareBase } from "./LayoutAwareBase";

export class LayoutAware<PT = {||}, ST = {||}> extends LayoutAwareBase<
  PT,
  ST,
> {}
